import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CustomerValidationRequest } from 'src/app/models/customerValidationRequest';
import { CustomerValidationResponse } from 'src/app/models/customerValidationResponse';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerCreditService {
  customerValidationUrl = `${environment.urlglobal_api}/api/v3/bancolombia/baas/cl/payment/client/validation`;

  constructor(private http: HttpClient) { }
  bancolombiaCustomerValidation(requestBody: CustomerValidationRequest): Observable<CustomerValidationResponse> {
    const headers = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    return this.http.post<CustomerValidationResponse>(
      this.customerValidationUrl,
      requestBody,
      headers
    ).pipe(map((response: CustomerValidationResponse) => response))
  }
}
